import { render, staticRenderFns } from "./PreApprovalLetterPreview.vue?vue&type=template&id=b536f7e4&scoped=true&"
import script from "./PreApprovalLetterPreview.vue?vue&type=script&lang=js&"
export * from "./PreApprovalLetterPreview.vue?vue&type=script&lang=js&"
import style0 from "./PreApprovalLetterPreview.vue?vue&type=style&index=0&id=b536f7e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b536f7e4",
  null
  
)

export default component.exports